import { render, staticRenderFns } from "./ChipStatus.vue?vue&type=template&id=54844b95"
import script from "./ChipStatus.vue?vue&type=script&lang=js"
export * from "./ChipStatus.vue?vue&type=script&lang=js"
import style0 from "./ChipStatus.vue?vue&type=style&index=0&id=54844b95&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54844b95')) {
      api.createRecord('54844b95', component.options)
    } else {
      api.reload('54844b95', component.options)
    }
    module.hot.accept("./ChipStatus.vue?vue&type=template&id=54844b95", function () {
      api.rerender('54844b95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commons/ChipStatus.vue"
export default component.exports